module.exports = __webpack_public_path__ + "static/img/2.e7b97eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/2.png
// module id = 1MXf
// module chunks = 5